{
    "NAME": "LoggingSettingsLanguage",
    "LoggingSettings_Column_Component": "Component",
    "LoggingSettings_Column_Enabled": "Enabled",
    "LoggingSettings_Column_BackupLogs": "Backup Logs",
    "LoggingSettings_Column_Level": "Level",
    "LoggingSettings_Column_RollOverFiles": "Rollover Files",
    "LoggingSettings_Column_MaxFileSizeAsMB": "Max File Size (MB)",
    "LoggingSettings_Component_MainServlet": "Main Servlet",
    "LoggingSettings_Component_Database": "Database",
    "LoggingSettings_Component_Repository": "Repository",
    "LoggingSettings_Component_RptExecMgr": "Report Execution Manager",
    "LoggingSettings_Component_MailController": "Mail Controller",
    "LoggingSettings_Component_TaskDelegator": "Task Delegator",
    "LoggingSettings_Component_TelephoneModule": "Telephone Module",
    "LoggingSettings_Component_OmniModule": "Omnichannel Module",
    "LoggingSettings_Action_Save": "Save",
    "LoggingSettings_Action_Cancel": "Cancel",
    "LoggingSettings_Action_Refresh": "Refresh",
    "LoggingSettings_ReadOnlyWarning": "You do not have global administration privileges to update logging settings.",
    "LoggingSettings_SaveSuccess": "Logging settings were saved.",
    "LoggingSettings_SaveError": "Unable to save logging settings.",
    "LoggingSettings_RefreshConfirmTitle": "Discard Unsaved Changes?",
    "LoggingSettings_RefreshConfirmBody": "Refreshing will discard your unsaved changes. Continue?",
    "LoggingSettings_Empty": "No logging settings are available."
}
